import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import { ENDPOINTS } from '../../../../shared/organizationPackages/helpers';
import type { PackageInventoryQueryParams } from '../../../helpers/packageInventory';
import type { FetchPackageDetailsResponse } from '../../../../shared/organizationPackages/response';

const fetchPackageDetails = (locator: string, params: PackageInventoryQueryParams) =>
  get<FetchPackageDetailsResponse>(`${ENDPOINTS.FETCH_PACKAGES}/${nuc(locator)}/versions`, true, params, {
    encodeQuery: true,
  });

export const getPackageDetailsQueryKey = (locator: string | undefined, params: PackageInventoryQueryParams) =>
  ['packages', locator, 'versions', params] as const;

export default function usePackageDetails(locator: string | undefined, params: PackageInventoryQueryParams) {
  return useQuery<FetchPackageDetailsResponse>({
    queryKey: getPackageDetailsQueryKey(locator, params),
    queryFn: () => {
      if (!locator) {
        throw new Error('A package locator is required to fetch package details.');
      }
      return fetchPackageDetails(locator, params);
    },
    enabled: !!locator,
    staleTime: 1000 * 60 * 5,
  });
}
